import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core'
import { map } from 'lodash';

var faBeamLight = {
  prefix: 'fas',
  iconName: 'beamlight',
  icon: [64, 64, [], 'e002', 'M8.54 62.96c0-4.13-3.34-7.47-7.47-7.47 4.13 0 7.47-3.34 7.47-7.47 0 4.13 3.34 7.47 7.47 7.47-4.13 0-7.47 3.34-7.47 7.47Zm46.95-46.95c0-4.13-3.34-7.47-7.47-7.47 4.13 0 7.47-3.34 7.47-7.47 0 4.13 3.34 7.47 7.47 7.47-4.13 0-7.47 3.34-7.47 7.47ZM57 53.06c0-2.38-2.2-4.24-4.67-3.67a3.745 3.745 0 0 0-2.78 2.79 3.79 3.79 0 0 0 3.68 4.67c2.09 0 3.78-1.69 3.78-3.78ZM14.74 10.97c0-2.09-1.69-3.78-3.78-3.78s-3.78 1.69-3.78 3.78 1.69 3.78 3.78 3.78 3.78-1.69 3.78-3.78Zm45.01 47.72c-.59 0-1.07.48-1.07 1.07 0 .28.11.55.31.75l3.2 3.2c.2.19.46.29.73.29.59 0 1.07-.48 1.07-1.07 0-.27-.1-.53-.29-.73L60.5 59c-.2-.2-.47-.31-.75-.31ZM1.07 0C.48 0 0 .48 0 1.07c0 .28.11.55.31.75l3.2 3.2c.2.19.46.29.73.29.59 0 1.07-.48 1.07-1.07 0-.27-.1-.53-.29-.73L1.82.31C1.62.11 1.35 0 1.07 0Zm58.87 33.54s-22.9.01-22.81.04l12.1 3.3c.48.13.81.57.82 1.06 0 .61-.49 1.1-1.1 1.1-.1 0-.2-.01-.3-.04H46.6l-10.01-2.94 9.98 10.76c.17.2.27.46.27.73 0 .59-.44 1.07-.99 1.07-.25 0-.49-.1-.68-.29L35.2 37.57l2.73 10.8c.02.09.03.19.03.28 0 .59-.44 1.07-.99 1.07-.44 0-.84-.32-.96-.78S33.04 37.2 33.04 37.2c-.03-.14-.03 22.13-.03 22.13v-.55c0 .55-.45 1-1 1s-1-.44-1-1v-2.04s0-20.64-.03-20.51l-3.02 10.88c-.12.43-.52.73-.97.73a.997.997 0 0 1-1.01-.99c0-.09.01-.18.04-.27s2.78-10 2.78-10l-10.15 9.98c-.19.2-.46.31-.73.31a.997.997 0 0 1-1.01-.99c0-.27.11-.53.32-.72l10.15-9.98-10.18 2.73c-.09.02-.18.03-.27.03a.997.997 0 0 1-1.01-.99c0-.44.3-.84.74-.96l11.07-2.97c.09-.02-20.87-.03-20.87-.03H5.27c-.55 0-1-.45-1-1s.44-1 .99-1H6.9s21 0 20.87-.03L16.7 27.94a1.007 1.007 0 0 1 .27-1.98c.09 0 .18.01.27.04l10.19 2.78-10.15-10.15a.984.984 0 0 1-.27-.69 1.005 1.005 0 0 1 1.69-.74l10.16 10.15-2.78-10.19c-.02-.09-.04-.18-.03-.27a1.007 1.007 0 0 1 1.98-.27v-.98l3.3 12.09c.04.15.04-22.79.04-22.79a1.102 1.102 0 0 1 2.2 0s0 22.93.04 22.79l3.3-12.09c.13-.48.57-.81 1.06-.81.61 0 1.1.49 1.1 1.1 0 .1-.01.2-.04.3S36 27.34 36 27.34l11.1-11.08a1.097 1.097 0 0 1 1.9.75c0 .3-.13.59-.35.8L37.56 28.9l11.13-3.03a1.097 1.097 0 0 1 1.39 1.06c0 .49-.33.93-.81 1.06l-12.1 3.3c-.15.04 22.81.04 22.81.04a1.102 1.102 0 0 1 0 2.2h-.01ZM36.01 33v.02s.08-.01.13-.01-.09 0-.13-.01Zm-8 .09v-.02h-.13s.08 0 .13.01Z']
}

library.add(
  faBeamLight,
)

export const customIcons = [
  'beamlight'
]

const customIconsDict = map(customIcons, (item) => ({'name': item}))

export const albaIconsList = {
  title: 'Alba',
  list: customIconsDict,
};

const CustomIcon = (props) => {
  const { name, size, className } = props;
  const formatedName = name
    .split(' ')
    .map((separetedName) => `fa-${separetedName}`)
    .join(' ');
  return (
    <>
    <FontAwesomeIcon icon={`fa-solid ${formatedName}`} className={`${className ? className : ''} ${size ? size : ''}`} />
    </>
  );
};

export default CustomIcon;